var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_997_42448)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 109,
    r: 105,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44116 42.0242L96.8768 95.7008L110.481 75.9758L110.394 53.2832L119.769 39.5804L28.0253 38.7949L6.44116 42.0242Z",
    fill: "#6592F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44116 42.0254L133.461 54.5063L152.734 94.8728L6.44116 42.0254Z",
    fill: "#CEE8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.65 12L119.769 39.5802L6.44116 42.024L108.65 12Z",
    fill: "#CEE8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226 171.846L164.795 183.265L161.232 169.547L165.93 156.939L163.504 147.406L214.642 165.672L226 171.846Z",
    fill: "#6592F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226 171.843L152.843 152.906L133.921 171.43L226 171.843Z",
    fill: "#CEE8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.274 134.332L163.503 147.405L225.999 171.844L175.274 134.332Z",
    fill: "#CEE8F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07274 156.693L37.4983 154.18L37.4411 146.777L33.3661 141.051L33.3016 135.913L9.96883 152.042L5.07274 156.693Z",
    fill: "#6592F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07171 156.693L39.4237 137.248L51.4753 144.036L5.07171 156.693Z",
    fill: "#CEE8F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5937 130.908L33.3003 135.912L5.07149 156.693L25.5937 130.908Z",
    fill: "#CEE8F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_997_42448",
    x: 0,
    y: 0,
    width: 226,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.25098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_997_42448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_997_42448",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLogo);
export default __webpack_public_path__ + "static/media/chat-logo.8fdc7eddc6b3e0fbf48c56acb7eb4cbe.svg";
export { ForwardRef as ReactComponent };